import React from 'react';
import { View, StyleSheet } from 'react-native';
import { colors } from '../theme';

type Props = {
  size?: number;
  color?: string;
};

/**
 * Ícone customizado de duas agulhas de crochê/tricô cruzadas em 'X'.
 * Substitui o ícone 'needle' do MaterialCommunityIcons (que lembrava seringa/agulha médica).
 */
export function TwoNeedlesIcon({ size = 28, color = colors.onSage }: Props) {
  const knobSize = Math.max(5, Math.round(size * 0.18));
  const shaftWidth = Math.max(2, Math.round(size * 0.08));
  const shaftHeight = Math.round(size * 0.78);
  const hookSize = Math.max(3, Math.round(size * 0.12));

  return (
    <View
      style={[styles.container, { width: size, height: size }]}
      testID="two-needles-icon"
      accessibilityRole="image"
      accessibilityLabel="Agulhas de crochê"
    >
      {/* Agulha 1: inclinada para a direita (\) */}
      <View
        style={[
          styles.needleWrapper,
          {
            transform: [{ rotate: '-38deg' }],
          },
        ]}
      >
        {/* Cabeça / Pomo superior */}
        <View
          style={[
            styles.knob,
            {
              width: knobSize,
              height: knobSize,
              borderRadius: knobSize / 2,
              backgroundColor: color,
            },
          ]}
        />
        {/* Haste da agulha */}
        <View
          style={[
            styles.shaft,
            {
              width: shaftWidth,
              height: shaftHeight,
              borderRadius: shaftWidth / 2,
              backgroundColor: color,
            },
          ]}
        />
        {/* Gancho de crochê inferior */}
        <View
          style={[
            styles.hookLeft,
            {
              width: hookSize,
              height: shaftWidth,
              backgroundColor: color,
              borderBottomLeftRadius: shaftWidth,
              borderTopLeftRadius: shaftWidth,
            },
          ]}
        />
      </View>

      {/* Agulha 2: inclinada para a esquerda (/) */}
      <View
        style={[
          styles.needleWrapper,
          {
            transform: [{ rotate: '38deg' }],
          },
        ]}
      >
        {/* Cabeça / Pomo superior */}
        <View
          style={[
            styles.knob,
            {
              width: knobSize,
              height: knobSize,
              borderRadius: knobSize / 2,
              backgroundColor: color,
            },
          ]}
        />
        {/* Haste da agulha */}
        <View
          style={[
            styles.shaft,
            {
              width: shaftWidth,
              height: shaftHeight,
              borderRadius: shaftWidth / 2,
              backgroundColor: color,
            },
          ]}
        />
        {/* Gancho de crochê inferior */}
        <View
          style={[
            styles.hookRight,
            {
              width: hookSize,
              height: shaftWidth,
              backgroundColor: color,
              borderBottomRightRadius: shaftWidth,
              borderTopRightRadius: shaftWidth,
            },
          ]}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  needleWrapper: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
  knob: {
    marginBottom: -1,
  },
  shaft: {},
  hookLeft: {
    marginTop: -2,
    alignSelf: 'flex-start',
  },
  hookRight: {
    marginTop: -2,
    alignSelf: 'flex-end',
  },
});
